module.exports = __webpack_public_path__ + "img/img4-5.2c0c0637.png";